import loadable from '@loadable/component'

export const MfeComponent = loadable(() => import('./Mfe'))
export default MfeComponent
